import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { Router } from '@angular/router';
import { map, take } from 'rxjs/operators';

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  return auth.isAuthenticated$.pipe(
    take(1),
    map(isAuthenticated => {
      if (!isAuthenticated) {
        console.log('Accesso negato. Reindirizzamento al login.');
        router.navigate(['/login']);
        return false;
      }
      console.log('Accesso consentito');
      //router.navigate(['/admin/dashboaard']);
      return true;
    })
  );
};
